import React from 'react';
import './App.css';
import Dashboard from './dashboard/Dashboard';
import SignUp from './features/login/SignUp';
import LoginScreen from './features/login/LoginScreen';
import { SessionContextProvider } from './features/login/SessionContext';
import { Authenticator } from './features/login/Authenticator';
import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from '@mui/material';
import theme from './theme';


function NotLoggedIn(props) {

  return (
    <Routes>
      <Route path="*" element={<LoginScreen successRedirect={'/'} />} />
      <Route path="/signup" element={<SignUp successRedirect={'/'} />} />
    </Routes>
  )
}

function App() {

  const authenticator = new Authenticator();

  return (
    <HashRouter>
      <ThemeProvider theme={theme}>


        <div className="App">
          <SessionContextProvider
            authenticator={authenticator}
            onSessionLoaded={null}
            noSession="/"
            noSessionContent={<NotLoggedIn />} >

            <Dashboard />

          </SessionContextProvider>

        </div>
      </ThemeProvider>

    </HashRouter>
  );
}

export default App;
